import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LocalServiceService } from '../shareModule/services/local-service.service';
import moment from 'moment';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthServiceService } from '../shareModule/services/auth-service.service';
import { CommonService } from '../shareModule/services/common.service';

@Component({
  selector: 'app-poll-form',
  templateUrl: './poll-form.component.html',
  styleUrl: './poll-form.component.scss'
})
export class PollFormComponent implements OnInit {

  public poll: any = {
    name: '',
    startDate: '',
    endDate: '',
    polls: [],
    openEndedQuestion: '',
    industryStandard: ''
  };

  public set productId(value){
    this._productId = value;
    this.cdr.detectChanges()
  }

  // public set categoryId(value){
  //   this._categoryId = value;
  //   this.poll.name = "Which Local Delight do you eat the most in your area?";
  //   this.cdr.detectChanges()
  // }
 public _isCategoryBased = false;
 public set isCategoryBased(val: boolean){
  this._isCategoryBased = val;
  this.cdr.detectChanges()
 }
 public onCategoryChange(e){
   this.selectedCategory = e;
   console.log({e})
 }

  public get productId(){
    return this._productId;
  }
  // public get categoryId(){
  //   return this._categoryId
  // }


  
  private _productId = null;
  private selectedCategory = null;
 // private _categoryId = null;

  constructor(private toastr: ToastrService, private local: LocalServiceService, public modalService: NgbModal,
    public modal: NgbActiveModal,
     private auth: AuthServiceService, private cdr: ChangeDetectorRef, private commonService: CommonService){

  }
  public categoryList = []
  ngOnInit(): void {
     this.commonService.categoryList.subscribe((val)=>{
      this.categoryList = val.map((e) => {
        return {
          keyName: e.name,
          sub: e.subCategory.map((i) => ({
            keyName: i.categoryName,
            ...i,
          }))
        }

      });
     })
   
  }
  
  storePoll() {
    try{
      console.log('adding poll....')
    const poll = this.poll;
    this.poll.categoryId = this.selectedCategory?.categorieChildId;

    // Validation

    if (
      (poll.name == '' ||
      poll.startDate == '' ||
      poll.endDate == '' ||
      poll.polls.length < 1) && !this.selectedCategory
    ) {
      return this.toastr.error('Please fill the inputs !');
    }

    const startDate = moment(poll.startDate, 'YYYY-MM-DD');
    const endDate = moment(poll.endDate, 'YYYY-MM-DD');

    if (!endDate.isAfter(startDate)) {
      return this.toastr.error('Start Date should be Greater then End date!');
    }

    // Validation

    this.poll.uuid = this.local.generateUUID();
    this.poll.productId = this._productId

    this.auth.poll_store(poll).subscribe(
      (response: any) => {

        this.modal.close();
        this.toastr.success('successfully added poll');

      },
      (e) => {

        this.toastr.error('failed to add poll');
      }
    );
    }
    catch(e){
      console.error(e);
      this.toastr.error("Something went wrong please try again latter")
    }
  }
  removePollsChild(i: number) {
    this.poll.polls = this.poll.polls.filter(
      (row: any, index: number) => index != i
    );
  }

  addPollsChild() {
    this.poll.polls = [...this.poll.polls, {}];
  }

}
